import React, { Component } from "react";
import { connect } from "react-redux";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Button from "react-validation/build/button";
import Select from "react-validation/build/select";
import moment from "moment";
import DatePicker from "react-datepicker";
import * as validations from "./lib/validations";
import { Redirect } from "react-router-dom";
import {
  registrationInquiryInsertUpdate,
  clearUpdate,
  getAllSyllabus,
  getAllSection,
  checkUserVerifyOtpDetails,
  ResendOtpDetails,
  getAllAdvertisement,
} from "../actions";
import updateGrid from "../utils/updateGrid";
import SelectAdvance from "react-select";
import Modal from "react-responsive-modal";
import textToCapitalize from "../utils/textToCapitalize";
import _ from "lodash";
import flowImage from "../img/flow.png";
import { prefixlist } from "../utils/enums";

const keys = require("../config/keys");

class OnlineRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      programId: [],
      birthRequired: false,
      modelOpen: false,
      allCourses: [],
      ShowThankMsg: false,
      ShowOtpBox: true,
      modelAlertOpen: false,
      PrefixId: 0,
      mobileError: 0,
      mobileErrMsg: "",
    };
  }

  onOpenModal = () => {
    this.setState({ modelOpen: true });
  };

  onCloseModal = () => {
    this.setState({ modelOpen: false });
  };

  onOpenModalAlert = () => {
    this.setState({ modelAlertOpen: true });
  };

  onCloseModalAlert = () => {
    this.setState({ modelAlertOpen: false });
  };

  birthDate = (date) => {
    this.setState({
      dateOfBirth: date,
    });
    if (date) {
      this.setState({
        birthRequired: false,
      });
    } else {
      this.setState({
        birthRequired: true,
      });
    }
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onInputOtpChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, errorMsg: false });
  };

  onInputGenderChange = (e) => {
    this.setState({
      genderId: e.target.value,
      gender: e.target[e.target.selectedIndex].text,
    });
  };
  componentWillMount() {
    this.props.getAllSyllabus();
    this.props.getAllSection();
    this.props.getAllAdvertisement();
  }
  componentDidUpdate() {
    updateGrid(this);
  }
  handleSectionChange = (selectedOption) => {
    var selectedCourses = [];
    if(selectedOption) {
      selectedCourses = this.props.syllabusMaster.filter(
        (i) => i.SectionId === selectedOption.value
      );  
    }

    this.setState({
      sectionId: selectedOption ? selectedOption.value : 0,
      allCourses: selectedCourses,
    });
  };
  handleProgramsChange = (programId) => {
    this.setState({ programId });
  };

  handleOtpSubmit = async (e) => {
    e.preventDefault();
    var userOtpData = {
      UserId: this.props.userRegistrationDetails.Id,
      OtpCode: this.state.otpNumber,
    };
    var res = await this.props.checkUserVerifyOtpDetails(userOtpData);
    if (res.isOtpVerify) {
      this.setState({
        ShowThankMsg: true,
        ShowOtpBox: false,
        errorMsg: false,
      });
      // setTimeout(() => {
      //   this.onCloseModal;
      // }, 5000);
    } else {
      this.setState({
        ShowThankMsg: false,
        ShowOtpBox: true,
        errorMsg: res.errorMsg,
      });
    }
  };

  clearForm = (e) => {
    e.preventDefault();
    this.setState({
      firstName: "",
      middleName: "",
      lastName: "",
      genderId: 0,
      dateOfBirth: null,
      nationality: 0,
      email: "",
      mobile: "",
      comments: "",
      sectionId: 0,
      programId: 0,
    });
  };

  handleAdvertisementChange = (selectedOption) => {
    var objAdvertType = this.props.advertisementList.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objAdvertType.length > 0) {
      this.setState({
        advertisementId: selectedOption.target.value || 0,
        advertisement: objAdvertType[0].Advertisement || "",
      });
    }
  };
  renderAdvertisement = () => {
    return _.sortBy(this.props.advertisementList, "Advertisement").map(
      (data) => {
        return (
          <option key={data.Id} value={data.Id}>
            {data.Advertisement}
          </option>
        );
      }
    );
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    if (this.state.sectionId > 0 && this.state.programId.length > 0) {
      let flagMobileErr = 0, mobileErrMsg = "";
      if (this.state.nationality === "Indian" && this.state.mobile.trim().length !== 10) {
        flagMobileErr = 1;
        mobileErrMsg = "Mobile must be 10 digits."
      } else if (this.state.nationality !== "Indian" && (this.state.mobile.trim().length < 7 || this.state.mobile.trim().length > 15)) {
        flagMobileErr = 1;
        mobileErrMsg = "Mobile must be between 7 and 15 digits."
      } else {
        flagMobileErr = 0;
        mobileErrMsg = ""
      }

      var _dob = null;
      if (
        this.state.dateOfBirth !== undefined &&
        this.state.dateOfBirth !== null
      ) {
        _dob = moment(this.state.dateOfBirth).format("YYYY-MM-DD");
      }
      const registration = {
        prefixId: this.state.PrefixId,
        FirstName: textToCapitalize(this.state.firstName),
        MiddleName: textToCapitalize(this.state.middleName),
        LastName: textToCapitalize(this.state.lastName),
        GenderId: parseInt(this.state.genderId, 10),
        Gender: this.state.gender,
        DOB: _dob,
        Nationality: this.state.nationality,
        Email: this.state.email,
        StudMobNo: this.state.mobile,
        SectionId: this.state.sectionId,
        SyllabusId: this.state.programId || [],
        Comments: textToCapitalize(this.state.comments),
        Advertisement: this.state.advertisement,
        IsActive: 1,
        IsDelete: 0,
        IsSignUp: 0,
        CreatedBy: 0,
        UpdatedBy: 0,
        Id: 0,
      };

      this.setState({
        birthRequired: _dob !== null ? false : true,
        mobileError: flagMobileErr === 1 ? 1 : 0,
        mobileErrMsg: flagMobileErr === 1 ? mobileErrMsg : "",
      });

      // console.log("registration:-", registration);
      if (_dob !== null && flagMobileErr === 0) {
        var isRegSuccess = await this.props.registrationInquiryInsertUpdate(
          registration
        );
        this.setState({
          birthRequired: false,
        });
        if (isRegSuccess) {
          this.setState({ modelOpen: true });
        }
      } else {
        /*
        this.setState({
          birthRequired: true,
        });
        */
      }
    } else {
      this.setState({
        modelAlertOpen: true,
        modelAlertTitle: `Required`,
        modelAlertMsg: `Please select degree and program.`,
        modelAlertButton: "Ok",
      });
    }
  };

  
  handlePrefixChange = (selectedOption) => {
   
    this.setState({ PrefixId: parseInt(selectedOption.target.value) });
  };
  render() {
    if (
      this.props.auth.redirectToApplication === true &&
      this.props.auth.logOut === false &&
      this.props.auth.userType === 6
    ) {
      return <Redirect to="/Account/StudentAccount/AdmissionForm/0" />;
    }

    return (
      <div className="container">
        <Modal
          open={this.state.modelOpen}
          onClose={this.onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          showCloseIcon={this.state.ShowThankMsg}
          classNames={{
            overlay: "modalMsgBox modalPopupDesign",
            modal: "modalPopupInner",
          }}
        >
          <Form onSubmit={this.handleOtpSubmit.bind(this)}>
            {this.state.ShowThankMsg && (
              <div className="regMassage">
                <div
                  dangerouslySetInnerHTML={{
                    __html: keys.websiteSetting.EnquiryMsgModal,
                  }}
                />
                {/* Thank you for Enquiry. <br />
                Our team will get back to you shortly. */}
              </div>
            )}
            {this.state.ShowOtpBox && (
              <div className="modalVerify">
                <div className="regMassage modalTitle">
                  Please Verify OTP Number.
                </div>
                <div className="innerFormModal">
                  <div className="form-group">
                    <Input
                      type="number"
                      className="form-control otpBox"
                      id="otpNumber"
                      value={this.state.otpNumber}
                      validations={[validations.required]}
                      name="otpNumber"
                      label="OTP Number"
                      placeholder="Enter OTP"
                      onChange={this.onInputOtpChange}
                    />
                    {this.state.errorMsg && (
                      <p style={{ color: "#ff0000" }}>Invalid OTP</p>
                    )}
                  </div>
                  <div className="popupButtons text-center">
                    <Button
                      type="submit"
                      className="btn btn-success btn-lg theme-btn"
                    >
                      Submit
                    </Button>
                    <button
                      type="button"
                      className="btn btn-info btn-lg theme-btn"
                      onClick={this.props.ResendOtpDetails.bind(this, {
                        UserId: this.props.userRegistrationDetails.Id,
                        StudMobNo: this.props.userRegistrationDetails.StudMobNo,
                      })}
                    >
                      Resend OTP
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Form>
        </Modal>

        <Modal
          open={this.state.modelAlertOpen}
          onClose={this.onCloseModalAlert}
          center
          classNames={{
            overlay: "comfirm_modal_opacity",
            modal: "comfirm_modal",
            transitionEnter: "transitionEnter,",
            transitionEnterActive: "transitionEnterActive",
            transitionExit: "transitionExitActive",
            transitionExitActive: "transitionExitActive",
          }}
        >
          <div className="row">
            <div className="col-lg-12">
              <span>
                <h3>{this.state.modelAlertTitle}</h3>
                <h5
                  className="text-left"
                  dangerouslySetInnerHTML={{
                    __html: this.state.modelAlertMsg,
                  }}
                />
              </span>
            </div>

            <div className="col-lg-12">
              <center>
                <button
                  type="button"
                  onClick={this.onCloseModalAlert}
                  className="btn btn-success btn-lg"
                >
                  <i className="fa fa-check">&nbsp;</i>
                  {this.state.modelAlertButton}
                </button>
              </center>
            </div>
          </div>
        </Modal>

        <div className="reg-form">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <center>
                <img src={flowImage} alt="flowImage" />
              </center>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 regform_left">
              <div
                dangerouslySetInnerHTML={{
                  __html: keys.websiteSetting.EnquiryContent,
                }}
                className="bg-full"
              />
            </div>

            <div className="col-lg-6  col-md-6 col-sm-12 regform_right">
              <div className="regformRightBg">
                <Form
                  onSubmit={this.handleSubmit.bind(this)}
                  className="textTransCapitalize"
                >
                  <div className="login-header">
                    <h2>Admission Enquiry</h2>
                  </div>

                  <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Prefix</label>
                        <Select
                          className="form-control"
                          id="PrefixId"
                          validations={[validations.requiredSelect]}
                          name="PrefixId"
                          value={this.state.PrefixId}
                          onChange={this.handlePrefixChange}
                          label="Prefix"
                        >
                          <option value="0">-- Select --</option>
                          {_.uniqBy(prefixlist, "Id").map((item) => {
                            return <option value={item.Id}>{item.Name}</option>;
                          })}
                        </Select>
                      </div>
                    </div>

                    <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Full Name</label>
                        <Input
                          type="text"
                          className="form-control"
                          id="firstName"
                          value={this.state.firstName || ""}
                          validations={[validations.required]}
                          name="firstName"
                          label="First Name"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    {/* <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">First Name</label>
                        <Input
                          type="text"
                          className="form-control"
                          id="firstName"
                          value={this.state.firstName || ""}
                          validations={[validations.required]}
                          name="firstName"
                          label="First Name"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Middle Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="middleName"
                          value={this.state.middleName || ""}
                          name="middleName"
                          label="Middle Name"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Last Name</label>
                        <Input
                          type="text"
                          className="form-control"
                          id="lastName"
                          value={this.state.lastName || ""}
                          validations={[validations.required]}
                          name="lastName"
                          label="Last Name"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div> */}
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Gender</label>
                        <Select
                          className="form-control"
                          id="genderId"
                          validations={[validations.requiredSelect]}
                          name="genderId"
                          value={this.state.genderId}
                          label="Gender"
                          onChange={this.onInputGenderChange}
                        >
                          <option value="0">-- Select --</option>
                          <option value="1">Male</option>
                          <option value="2">Female</option>
                          <option value="3">Transgender</option>
                        </Select>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">DOB</label>
                        <DatePicker
                          selected={this.state.dateOfBirth}
                          onChange={this.birthDate}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          dateFormat={this.props.systemConfig.DateFormat}
                          // maxDate={moment().subtract(15, "years")}
                          maxDate={moment(
                            `${this.props.admissionConfiguration.length > 0 ?
                              this.props.admissionConfiguration[0].AyName
                              .substring(0,this.props.admissionConfiguration[0].AyName
                              .indexOf("-"))
                              : moment().format("YYYY")}1231`)
                              .subtract(16, "years")}
                          yearDropdownItemNumber={15}
                          scrollableYearDropdown
                          placeholderText="DD/MM/YYYY"
                          validations={[validations.required]}
                        />
                        {this.state.birthRequired && (
                          <span className="require_field">
                            Date OF Birth is Required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Nationality</label>
                        <select
                          className="form-control"
                          id="nationality"
                          name="nationality"
                          value={this.state.nationality || ""}
                          label="Nationality"
                          onChange={this.onInputChange}
                        >
                          <option value="0">-- Select --</option>
                          <option>Indian</option>
                          <option>NRI</option>
                          <option>PIO</option>
                          <option>Foreigner</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Email</label>
                        <Input
                          type="email"
                          label="Email"
                          className="form-control"
                          id="email"
                          value={this.state.email || ""}
                          validations={[
                            validations.required,
                            validations.email,
                          ]}
                          name="email"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    {/* <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Mobile</label>
                        <Input
                          type="number"
                          className="form-control"
                          id="mobile"
                          value={this.state.mobile || ""}
                          validations={
                            ([validations.required], [validations.minLength])
                          }
                          name="mobile"
                          label="Mobile"
                          onChange={this.onInputChange}
                          onKeyDown={(e) => {

                            if (e.target.value.length > 9) {
                              if(e.key !== "Backspace"){
                                e.preventDefault()
                              }
                      
                              this.setState({ mobileError: true })
                            } else {
                              this.setState({ mobileError: false })
                            }
                          }}
                        />
                         {this.state.mobileError && <span style={{ color: 'red', fontSize: '10px', fontWeight: 'bold' }} >Mobile number should not be more than 10 digits </span>}
                      </div>
                    </div> */}
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Mobile</label>
                        <Input
                          type="number"
                          className="form-control"
                          id="mobile"
                          value={this.state.mobile || ""}
                          validations={
                            ([validations.required])
                          }
                          name="mobile"
                          label="Mobile"
                          onChange={this.onInputChange}
                        />
                        {this.state.mobileError === 1 ? (
                          <span className="require_field">
                            {this.state.mobileErrMsg}
                          </span>
                        ) : ("")}
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form-group mb-0 forApplying">
                        <label>Applying For</label>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        {/* <label className="required">Degree</label> */}
                        <label className="required">Level of Program </label>
                        <SelectAdvance
                          name="sections"
                          value={this.state.sectionId}
                          onChange={this.handleSectionChange}
                          label="Sections"
                          options={_.sortBy(
                            this.props.sectionMaster,
                            "SectionName"
                          ).map((item) => {
                            return {
                              value: item.Id,
                              label: item.SectionName,
                            };
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        {/* <label className="required">Programs</label> */}
                        <label className="required">Name of Program</label>
                        <SelectAdvance
                          id="programId"
                          name="programId"
                          value={this.state.programId}
                          multi
                          onChange={this.handleProgramsChange}
                          label="Programs"
                          options={_.sortBy(
                            this.state.allCourses,
                            "CourseName"
                          ).map((item) => {
                            return {
                              value: item.CourseID,
                              label: item.CourseName,
                            };
                          })}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label> Any query </label>
                        {/* Comments */}
                        <textarea
                          rows="3"
                          className="form-control"
                          value={this.state.comments || ""}
                          name="comments"
                          label="Comments"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        {keys.websiteSetting.signUpContent === "nvu" ? (
                          <label className="required">
                            How do you know Navrachana University
                          </label>
                        ) : (
                          <label className="required">
                            Where did you hear from?
                          </label>
                        )}
                        <Select
                          onChange={this.handleAdvertisementChange}
                          id="advertisementId"
                          name="advertisementId"
                          className="form-control"
                          value={this.state.advertisementId || 0}
                          validations={[validations.requiredSelect]}
                          label="Where did you here for"
                        >
                          <option value="0">-- Select --</option>
                          {this.renderAdvertisement()}
                        </Select>
                      </div>
                    </div>

                    <div className="col col-lg-12 mt-1">
                      <Button
                        type="submit"
                        className="btn btn-success btn-lg theme-btn"
                      >
                        <i className="fa fa-save" />
                        Submit
                      </Button>

                      <button
                        type="button"
                        className="btn btn-danger btn-lg theme-btn"
                        onClick={this.clearForm}
                      >
                        <i className="fa fa-times" />
                        Cancel
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps({
  auth,
  systemConfig,
  update,
  sectionMaster,
  syllabusMaster,
  userRegistrationDetails,
  advertisementList,
  admissionConfiguration
}) {
  return {
    auth,
    systemConfig,
    update,
    sectionMaster,
    syllabusMaster,
    userRegistrationDetails,
    advertisementList,
    admissionConfiguration
  };
}
export default connect(mapStateToProps, {
  registrationInquiryInsertUpdate,
  clearUpdate,
  getAllSyllabus,
  getAllSection,
  checkUserVerifyOtpDetails,
  ResendOtpDetails,
  getAllAdvertisement,
})(OnlineRegistration);



// WEBPACK FOOTER //
// ./src/components/OnlineRegistration.js